import { createContext, useContext } from 'react';

import { useResponsive } from '@actual-app/components/hooks/useResponsive';

/**
 * Ventanas heredadas (modales de upstream) que en el móvil se pintan como
 * Hoja de Rumbo: suben desde abajo, con asa, título a la izquierda, X
 * redonda de 40 px y botones de bloque a todo el ancho (H01).
 *
 * Es opt-in: un modal que no está aquí se pinta igual que siempre (los
 * autocompletes y menús de upstream dependen de la ventana centrada). En
 * escritorio no cambia nada. Cómo añadir uno: docs-vadym/hojas.md.
 */
export const MODALES_EN_HOJA: ReadonlySet<string> = new Set([
  // Tanda 1 (H01)
  'notes',
  'edit-field',
  'close-account',
  'confirm-delete',
  'confirm-category-delete',
  'confirm-transaction-edit',
  'confirm-unlink-account',
  'convert-to-schedule',
  // 'hold-buffer' ya no: en el móvil lo pinta HojaReservar (B6 · H37).
  // Tanda 2 (B6 · H01): formularios sencillos sin desplegables.
  'account-reconcile',
  'enablebanking-init',
]);

/** Decide si el modal `nombre` se pinta como hoja o como ventana. */
export function debePintarseEnHoja(
  nombre: string,
  esEstrecho: boolean,
  registro: ReadonlySet<string> = MODALES_EN_HOJA,
): boolean {
  return esEstrecho && registro.has(nombre);
}

/**
 * Para el componente que monta el `<Modal name=…>`: si va en hoja, cambia su
 * contenido (botones de bloque, selector dentro de la hoja…).
 */
export function useModalEnHoja(nombre: string): boolean {
  const { isNarrowWidth } = useResponsive();
  return debePintarseEnHoja(nombre, isNarrowWidth);
}

/**
 * Lo pone `Modal` alrededor de su contenido: `ModalHeader` y
 * `ModalCloseButton` lo leen para pintarse al estilo de la hoja sin que cada
 * modal tenga que cambiarlos.
 */
export const ModalEnHojaContext = createContext(false);

export function useDentroDeHoja(): boolean {
  return useContext(ModalEnHojaContext);
}
